import React from 'react';
import { getPermissionsForModule, Scopes } from 'src/app/scopes/scopes';

import CompanieInfo from './Children/Info';
import Companies from './Children/Companies';
import Update from './Children/Update';
import InfoBilling from './Children/BillingInformation';
import TaxInformation from "./Children/TaxInformation";

export const CompaniesConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      id: 'companiesGroup',
      path: 'companies',
      scopes: getPermissionsForModule('Company'),
      children: [
        {
          scopes: [Scopes.Company.show],
          id: 'companiesGroup.main',
          path: '',
          element: <Companies />,
        },
        {
          scopes: [Scopes.Company.update],
          id: 'companiesGroup.update',
          path: 'update',
          element: <Update />,
        },
        {
          scopes: [Scopes.Company.show],
          path: 'info/:id',
          children: [
            {
              id: 'companiesGroup.info',
              path: '',
              element: <CompanieInfo />,
            },
            {
              id: 'companiesGroup.info',
              path: 'billing',
              element: <InfoBilling />,
            },
            {
              scopes: [Scopes.Company.update],
              id: 'companiesGroup.taxInformation',
              path: `tax-information`,
              element: <TaxInformation />,
            },
          ],
        },
      ],
    },
  ],
};
